export default __webpack_public_path__ + "static/media/atlasLogoLight.bcd21c8b.png";